'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-click-n-hold/~/react/react.js
// module id = 970
// module chunks = 0